<template>
  <div class="statistics-container">
    <div class="statisticsHead">
      <!-- 头部标题和筛选 -->
      <div class="header-section">
        <div class="header-title">
          <i class="el-icon-s-marketing header-icon"></i>
          <span>数据统计分析</span>
        </div>
        <!-- <div class="header-actions">
          <el-button size="mini" plain icon="el-icon-setting">自定义指标</el-button>
        </div> -->
      </div>

      <!-- 筛选栏 -->
      <div class="filter-section">
        <div class="filter-left">
          <div class="filter-item">
            <span class="label">统计周期</span>
            <el-radio-group v-model="period" size="small" @change="loadAllData">
              <el-radio-button label="day">本日</el-radio-button>
              <el-radio-button label="week">本周</el-radio-button>
              <el-radio-button label="month">本月</el-radio-button>
              <el-radio-button label="quarter">本季</el-radio-button>
            </el-radio-group>
          </div>
          <!-- <div class="filter-item">
            <span class="label">观察维度</span>
            <el-select v-model="dimension" size="small" style="width: 120px" @change="loadAllData">
              <el-option label="结算效率" value="efficiency"></el-option>
            </el-select>
          </div> -->
          <div class="filter-item">
            <span class="label">税源地</span>
            <el-select v-model="bodyId" placeholder="请选择" style="width:100%" clearable filterable @change="loadAllData">
                <el-option
                  v-for="item in bodyPageList"
                  :key="item.id"
                  :label="`${item.bodyName}-${item.abbreviation}`"
                  :value="item.id">
                </el-option>
            </el-select>
          </div>
          <!-- <div class="filter-item">
            <span class="label">来源</span>
            <el-select v-model="sourceOrg" size="small" style="width: 120px" placeholder="全部来源" clearable @change="loadAllData">
              <el-option label="全部来源" value=""></el-option>
              <el-option label="海因" value="HY-海因"></el-option>
              <el-option label="财天下" value="空-财天下"></el-option>
            </el-select>
          </div> -->
        </div>
        <div class="filter-right">
          <el-button type="primary" size="small" plain icon="el-icon-download" @click="exportData">导出统计</el-button>
          <!-- <div class="alert-info">
            <i class="el-icon-info"></i>
            <span>全部区域 本月重点关注: 结算效率, 结算成功率 96.8%, 待处理事项 44 项</span>
          </div>
          <el-button type="primary" size="small" plain icon="el-icon-download">导出统计</el-button> -->
        </div>
      </div>
    </div>
    <div class="statisticsBody">
      <!-- 顶部四张大卡片 -->
      <el-row :gutter="16" class="top-cards-row">
        <el-col :span="6" v-for="(card, index) in topCards" :key="index">
          <div class="top-card" :class="'top-card-' + index">
            <div class="card-icon" :style="{ background: card.iconBg, color: card.color }">
              <i :class="card.icon"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ card.value }}<span class="unit" v-if="card.unit">{{ card.unit }}</span></div>
              <div class="card-label">{{ card.label }}</div>
              <!-- <div class="card-trend">
                <i class="el-icon-top"></i>
                <span>本月新增 {{ card.trendValue }}</span>
              </div> -->
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 中部六张中卡片 -->
      <el-row :gutter="16" class="middle-cards-row">
        <el-col :span="4" v-for="(card, index) in middleCards" :key="index">
          <div class="middle-card">
            <div class="card-header">
              <span class="label">{{ card.label }}</span>
              <i :class="card.icon" :style="{ color: card.iconColor }"></i>
            </div>
            <div class="card-value" :style="{ color: card.valueColor }">{{ card.value }}</div>
            <!-- <div class="card-footer">
              <span class="sub-label">{{ card.subLabel }}</span>
              <span class="status-tag" :style="{ background: card.statusBg, color: card.statusColor }">{{ card.statusText }}</span>
            </div> -->
            <div class="progress-bar" :style="{ background: card.valueColor, width: card.progress + '%' }"></div>
          </div>
        </el-col>
      </el-row>

      <!-- 第三排四张详细卡片 -->
      <!-- <el-row :gutter="16" class="detail-cards-row">
        <el-col :span="6" v-for="(card, index) in detailCards" :key="index">
          <div class="detail-card">
            <div class="card-top">
              <i :class="card.icon" :style="{ color: card.color }"></i>
              <span class="status-tag" :style="{ background: card.statusBg, color: card.color }">{{ card.statusText }}</span>
            </div>
            <div class="card-title">{{ card.label }}</div>
            <div class="card-value">{{ card.value }}</div>
            <div class="card-desc">{{ card.desc }}</div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第一组图表 -->
      <el-row :gutter="16" class="bottom-charts-row">
        <el-col :span="9">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">月度结算趋势</div>
              <div class="actions">
                <el-radio-group v-model="settlementMonthRange" size="mini" @change="loadSettlementTrend">
                  <el-radio-button label="6">近6月</el-radio-button>
                  <el-radio-button label="12">近12月</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div ref="trendChart" class="chart-container-inner"></div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">任务状态分布</div>
            </div>
            <div ref="statusChart" class="chart-container-inner"></div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="chart-card ranking-card">
            <div class="chart-header">
              <div class="title">地区分布 TOP5</div>
            </div>
            <div class="ranking-list">
              <div v-for="(item, index) in regionDistributionList" :key="index" class="ranking-item">
                <div class="ranking-info">
                  <span class="rank-num" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
                  <span class="rank-name">{{ item.bodyName }}</span>
                </div>
                <div class="ranking-bar-wrapper">
                  <el-progress :percentage="item.ratio || 0" :show-text="false" :color="item.color" :stroke-width="8"></el-progress>
                  <span class="rank-value">{{ item.ratio || 0 }}%</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二组图表 -->
      <el-row :gutter="16" class="charts-row-2">
        <el-col :span="9">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">月度开票金额趋势</div>
              <div class="actions">
                <el-radio-group v-model="invoiceMonthRange" size="mini" @change="loadInvoiceTrend">
                  <el-radio-button label="6">近6月</el-radio-button>
                  <el-radio-button label="12">近12月</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div ref="invoiceTrendChart" class="chart-container-inner"></div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">合同状态分布</div>
            </div>
            <div ref="contractStatusChart" class="chart-container-inner"></div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">来源方企业统计</div>
            </div>
            <div ref="sourceEnterpriseChart" class="chart-container-inner"></div>
          </div>
        </el-col>
      </el-row>

      <!-- 第三组图表 -->
      <el-row :gutter="16" class="charts-row-3">
        <el-col :span="11">
          <div class="table-card">
            <div class="table-header">
              <div class="title">来源方企业明细</div>
              <div class="table-info">共 {{ sourceEnterpriseList.length }} 个来源方企业</div>
            </div>
            <div class="table-wrapper">
              <el-table :data="sourceEnterpriseList" stripe border style="width: 100%" height="260">
                <el-table-column prop="sourceOrg" label="来源方" width="140"></el-table-column>
                <el-table-column prop="companyCount" label="对应企业数" width="100" align="center"></el-table-column>
                <el-table-column prop="taskCount" label="任务量" width="100" align="center"></el-table-column>
                <el-table-column prop="settlementAmount" label="结算金额" width="120" align="center">
                  <template slot-scope="scope">
                    {{ formatMoney(scope.row.settlementAmount) }}
                  </template>
                </el-table-column>
                <el-table-column prop="ratio" label="占比" align="center">
                  <template slot-scope="scope">
                    <el-tag type="info" size="small">{{ scope.row.ratio }}%</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">来源方企业占比</div>
            </div>
            <div ref="sourceProportionChart" class="chart-container-inner"></div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">来源方下企业统计</div>
            </div>
            <div ref="sourceSubEnterpriseChart" class="chart-container-inner"></div>
          </div>
        </el-col>
      </el-row>

      <!-- 第四组图表 -->
      <el-row :gutter="16" class="charts-row-4">
        <el-col :span="12">
          <div class="table-card">
            <div class="table-header">
              <div class="title">来源方下企业明细</div>
              <el-tag type="success" size="small">共 {{ subEnterpriseList.length }} 家具体企业</el-tag>
            </div>
            <div class="table-wrapper">
              <el-table :data="subEnterpriseList" stripe border style="width: 100%" height="260">
                <el-table-column prop="sourceOrg" label="来源方" width="140"></el-table-column>
                <el-table-column prop="enterpriseName" label="对应企业"></el-table-column>
                <el-table-column prop="taskCount" label="任务量" width="100" align="center"></el-table-column>
                <el-table-column prop="settlementAmount" label="结算金额" width="120" align="center">
                  <template slot-scope="scope">
                    {{ formatMoney(scope.row.settlementAmount) }}
                  </template>
                </el-table-column>
                <el-table-column prop="cooperationStatus" label="合作状态" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="getStatusType(scope.row.cooperationStatus)" size="small">{{ scope.row.cooperationStatus }}</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="chart-card">
            <div class="chart-header">
              <div class="title">月度新增企业</div>
              <div class="actions">
                <el-radio-group v-model="newCompanyMonthRange" size="mini" @change="loadNewCompanyTrend">
                  <el-radio-button label="6">近6月</el-radio-button>
                  <el-radio-button label="12">近12月</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div ref="monthlyNewEnterpriseChart" class="chart-container-inner"></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="table-card">
            <div class="table-header">
              <div class="title">最近操作记录</div>
              <!-- <el-button type="text" size="small" style="color: #409EFF;">查看全部</el-button> -->
            </div>
            <div class="table-wrapper">
              <el-table :data="operationLogList" stripe border height="260">
                <el-table-column prop="creatorName" label="操作人" width="60"></el-table-column>
                <el-table-column prop="operation" label="操作内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="module" label="模块" width="60"></el-table-column>
                <el-table-column prop="createDate" label="操作时间" width="80"></el-table-column>
                <!-- <el-table-column prop="result" label="结果" width="80" align="center">
                  <template slot-scope="scope">
                    <el-tag type="success" size="small">{{ scope.row.result }}</el-tag>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import Cookies from 'js-cookie'
import qs from 'qs'
// import mixinViewModule from '@/mixins/view-module'

export default {
  name: 'TaskStatistics',
	// mixins: [mixinViewModule],
  data() {
    return {
      // mixinViewModuleOptions: {
      //   isBodyPage:true
      // },
      period: 'month',
      dimension: 'efficiency',
      bodyId: '',
      sourceOrg: '',
      settlementMonthRange: '6',
      invoiceMonthRange: '6',
      newCompanyMonthRange: '6',
      // 顶部卡片数据
      topCards: [
        { label: '累计任务量', value: '0', trendValue: '0', icon: 'el-icon-tickets', iconBg: '#e6f7ff', color: '#1890ff' },
        { label: '累计结算金额(元)', value: '0.00', unit: '万', trendValue: '0.00万', icon: 'el-icon-wallet', iconBg: '#f6ffed', color: '#52c41a' },
        { label: '累计开票数', value: '0', trendValue: '0', icon: 'el-icon-document', iconBg: '#fff7e6', color: '#fa8c16' },
        { label: '注册用户数', value: '0', trendValue: '0', icon: 'el-icon-user', iconBg: '#f9f0ff', color: '#722ed1' }
      ],
      // 中部卡片数据
      middleCards: [
        { label: '合作企业数', value: '0', icon: 'el-icon-office-building', iconColor: '#1890ff', subLabel: '本月新增 0 家', statusText: '活跃 0', statusBg: '#e6f7ff', statusColor: '#1890ff', valueColor: '#1890ff', progress: 0 },
        { label: '合同总数', value: '0', icon: 'el-icon-document-copy', iconColor: '#13c2c2', subLabel: '本月新增 0 份', statusText: '待审批 0', statusBg: '#e6fffb', statusColor: '#13c2c2', valueColor: '#13c2c2', progress: 0 },
        { label: '结算成功率', value: '0.00%', icon: 'el-icon-circle-check', iconColor: '#52c41a', subLabel: '较上月 0.00%', statusText: '优良', statusBg: '#f6ffed', statusColor: '#52c41a', valueColor: '#52c41a', progress: 0 },
        { label: '开票完成率', value: '0.00%', icon: 'el-icon-printer', iconColor: '#fa8c16', subLabel: '累计完成 0 张', statusText: '良好', statusBg: '#fff7e6', statusColor: '#fa8c16', valueColor: '#fa8c16', progress: 0 },
        { label: '日均结算额', value: '0.00万', icon: 'el-icon-pie-chart', iconColor: '#1890ff', subLabel: '较上月 0.00%', statusText: '上涨', statusBg: '#e6f7ff', statusColor: '#1890ff', valueColor: '#1890ff', progress: 0 },
        { label: '申报完成率', value: '0.00%', icon: 'el-icon-finished', iconColor: '#52c41a', subLabel: '本月已申报 0 人', statusText: '良好', statusBg: '#f6ffed', statusColor: '#52c41a', valueColor: '#52c41a', progress: 0 }
      ],
      // 详细卡片数据
      detailCards: [
        { label: '结算健康度', value: '0.00%', icon: 'el-icon-circle-check', color: '#52c41a', statusText: '稳定', statusBg: '#f6ffed', desc: '较上月提升 0.00%，待审核结算 0 单' },
        { label: '待办压力', value: '0 项', icon: 'el-icon-warning-outline', color: '#faad14', statusText: '正常', statusBg: '#fffbe6', desc: '合同、结算、开票合计待处理，建议优先处理结算与合同审核' },
        { label: '开票覆盖率', value: '0.00%', icon: 'el-icon-printer', color: '#fa8c16', statusText: '良好', statusBg: '#fff7e6', desc: '待开票 0 张，可结合结算完成批次推进' },
        { label: '区域集中度', value: '江苏 0%', icon: 'el-icon-location-outline', color: '#722ed1', statusText: '关注', statusBg: '#f9f0ff', desc: 'TOP3 区域资源待挖潜中，可补充区域筛选和商户分层看板' }
      ],
      // 地区分布数据
      regionDistributionList: [],
      // 来源方企业明细
      sourceEnterpriseList: [],
      // 来源方下企业明细
      subEnterpriseList: [],
      // 操作记录
      operationLogList: [],
      // 图表数据
      settlementTrendData: [],
      taskDistributionData: [],
      invoiceTrendData: [],
      contractStatusData: [],
      sourceEnterpriseData: [],
      sourceSubEnterpriseData: [],
      newCompanyTrendData: [],
      chartInstances: {},
      bodyPageList: []
    }
  },
  async mounted() {
    const res = await this.$http.get('/sys/plat/body/page?page=1&limit=1000',{});
    if(res.data.code !== 0){
      return this.$message.error(res.msg)
    }else{
      this.bodyPageList = res.data.data.list
      this.bodyId = this.bodyPageList.length > 0 ? this.bodyPageList[0].id : ''
    }
    this.$nextTick(() => {
      this.loadAllData()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    Object.values(this.chartInstances).forEach(c => c && c.dispose())
  },
  methods: {
    // 导出统计数据
    async exportData(){
      var params = qs.stringify({
        'access_token': Cookies.get('access_token'),
        "period":this.period,
        "bodyId":this.bodyId,
        "exportItems": "summary,partnerDetail,partnerEnterprise"
      })
	      window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/task/statistics/export?${params}`)
    },
    // 加载所有数据
    async loadAllData() {
      await Promise.all([
        this.loadOverview(),
        this.loadMetrics(),
        this.loadTaskDistribution(),
        this.loadRegionDistribution(),
        this.loadContractStatus(),
        this.loadSourceEnterprise(),
        this.loadSourceEnterpriseDetail(),
        this.loadPartnerEnterprise(),
        this.loadPartnerEnterpriseDetail(),
        this.loadSettlementTrend(),
        this.loadInvoiceTrend(),
        this.loadNewCompanyTrend(),
        this.loadOperationLog()
      ])
    },

    // 加载概览数据
    async loadOverview() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/overview', {
          params: {
            period: this.period,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          const data = res.data.data
          this.topCards[0].value = this.formatNumber(data.totalTasks)
          this.topCards[0].trendValue = this.formatNumber(data.monthTasks)
          this.topCards[1].value = this.formatMoneyWan(data.totalSettlement)
          this.topCards[1].trendValue = this.formatMoneyWan(data.monthSettlement) + '万'
          this.topCards[2].value = this.formatNumber(data.totalInvoices)
          this.topCards[2].trendValue = this.formatNumber(data.monthInvoices)
          this.topCards[3].value = this.formatNumber(data.totalUsers)
          this.topCards[3].trendValue = this.formatNumber(data.monthUsers)
        }
      } catch (error) {
        console.error('加载概览数据失败:', error)
      }
    },

    // 加载指标数据
    async loadMetrics() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/metrics', {
          params: {
            period: this.period,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          const data = res.data.data
          this.middleCards[0].value = this.formatNumber(data.companyCount)
          this.middleCards[0].progress = Math.min(data.companyCount / 2, 100)
          this.middleCards[1].value = this.formatNumber(data.contractCount)
          this.middleCards[1].progress = Math.min(data.contractCount / 5, 100)
          this.middleCards[2].value = (data.settleSuccessRate || 0).toFixed(2) + '%'
          this.middleCards[2].progress = Math.min(data.settleSuccessRate || 0, 100)
          this.middleCards[3].value = (data.invoiceCompleteRate || 0).toFixed(2) + '%'
          this.middleCards[3].progress = Math.min(data.invoiceCompleteRate || 0, 100)
          this.middleCards[4].value = this.formatMoneyWan(data.dailySettlement) + '万'
          this.middleCards[4].progress = Math.min((data.dailySettlement || 0) / 100 * 100, 100)
        }
      } catch (error) {
        console.error('加载指标数据失败:', error)
      }
    },

    // 加载任务状态分布
    async loadTaskDistribution() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/task-distribution', {
          params: {
            period: this.period,
            bodyId: this.bodyId
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.taskDistributionData = res.data.data
          this.initStatusChart()
        }
      } catch (error) {
        console.error('加载任务状态分布失败:', error)
      }
    },

    // 加载地区分布
    async loadRegionDistribution() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/region-distribution', {
          params: {
            period: this.period,
            bodyId: this.bodyId
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.regionDistributionList = res.data.data.map((item, index) => ({
            ...item,
            color: ['#1890ff', '#13c2c2', '#722ed1', '#fa8c16', '#faad14'][index]
          }))
        }
      } catch (error) {
        console.error('加载地区分布失败:', error)
      }
    },

    // 加载合同状态分布
    async loadContractStatus() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/contract-distribution', {
          params: {
            period: this.period,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.contractStatusData = res.data.data
          this.initContractStatusChart()
        }
      } catch (error) {
        console.error('加载合同状态分布失败:', error)
      }
    },

    // 加载来源方企业统计
    async loadSourceEnterprise() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/partner-stats', {
          params: {
            period: this.period,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.sourceEnterpriseData = res.data.data
          this.initSourceEnterpriseChart()
        }
      } catch (error) {
        console.error('加载来源方企业统计失败:', error)
      }
    },

    // 加载来源方企业明细
    async loadSourceEnterpriseDetail() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/partner-detail', {
          params: {
            period: this.period,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.sourceEnterpriseList = res.data.data
          this.initSourceProportionChart()
        }
      } catch (error) {
        console.error('加载来源方企业明细失败:', error)
      }
    },

    // 加载来源方下企业统计
    async loadPartnerEnterprise() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/partner-enterprise', {
          params: {
            period: this.period,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.sourceSubEnterpriseData = res.data.data
          this.initSourceSubEnterpriseChart()
        }
      } catch (error) {
        console.error('加载来源方下企业统计失败:', error)
      }
    },

    // 加载来源方下企业明细
    async loadPartnerEnterpriseDetail() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/partner-enterprise-detail', {
          params: {
            period: this.period,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.subEnterpriseList = res.data.data
        }
      } catch (error) {
        console.error('加载来源方下企业明细失败:', error)
      }
    },

    // 加载结算趋势
    async loadSettlementTrend() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/settlement-trend', {
          params: {
            monthRange: this.settlementMonthRange,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.settlementTrendData = res.data.data
          this.initTrendChart()
        }
      } catch (error) {
        console.error('加载结算趋势失败:', error)
      }
    },

    // 加载开票趋势
    async loadInvoiceTrend() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/invoice-trend', {
          params: {
            monthRange: this.invoiceMonthRange,
            bodyId: this.bodyId
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.invoiceTrendData = res.data.data
          this.initInvoiceTrendChart()
        }
      } catch (error) {
        console.error('加载开票趋势失败:', error)
      }
    },

    // 加载新增企业趋势
    async loadNewCompanyTrend() {
      try {
        const res = await this.$http.get('/sys/plat/task/statistics/new-company', {
          params: {
            monthRange: this.newCompanyMonthRange,
            bodyId: this.bodyId,
            sourceOrg: this.sourceOrg
          }
        })
        if (res.data.code === 0 && res.data.data) {
          this.newCompanyTrendData = res.data.data
          this.initMonthlyNewEnterpriseChart()
        }
      } catch (error) {
        console.error('加载新增企业趋势失败:', error)
      }
    },
    // 加载操作日志
    async loadOperationLog() {
      try {
        const res = await this.$http.get('/sys/log/operation/page?order=&orderField=&page=1&limit=10', {
          params: {
            
          }
        })
        if (res.data.code === 0 && res.data && res.data.data.list) {
          this.operationLogList = res.data.data.list || []
        }
      } catch (error) {
        console.error('加载操作日志失败:', error)
      }
    },

    // 初始化结算趋势图
    initTrendChart() {
      const dom = this.$refs.trendChart
      if (!dom) return
      if (this.chartInstances.trend) {
        this.chartInstances.trend.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.trend = chart
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.settlementTrendData.map(item => item.month),
          axisLine: { lineStyle: { color: '#f0f0f0' } },
          axisLabel: { color: '#999' }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#999',
            formatter: (value) => value === 0 ? '0' : this.formatMoneyWan(value) + '万'
          },
          splitLine: { lineStyle: { color: '#f5f5f5' } }
        },
        series: [{
          name: '结算金额',
          type: 'line',
          smooth: true,
          showSymbol: false,
          data: this.settlementTrendData.map(item => item.settlementAmount),
          itemStyle: { color: '#1890ff' },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(24, 144, 255, 0.2)' },
              { offset: 1, color: 'rgba(24, 144, 255, 0)' }
            ])
          },
          lineStyle: { width: 3 }
        }]
      })
    },

    // 初始化任务状态分布图
    initStatusChart() {
      const dom = this.$refs.statusChart
      if (!dom) return
      if (this.chartInstances.status) {
        this.chartInstances.status.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.status = chart
      chart.setOption({
        tooltip: { trigger: 'item' },
        legend: {
          bottom: '5%',
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: ['已完成', '待分配', '进行中']
        },
        series: [{
          name: '任务状态',
          type: 'pie',
          radius: ['45%', '70%'],
          center: ['50%', '45%'],
          avoidLabelOverlap: false,
          itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
          label: { show: false },
          emphasis: { label: { show: false } },
          data: [
            { value: this.taskDistributionData.completed || 0, name: '已完成', itemStyle: { color: '#52c41a' } },
            { value: this.taskDistributionData.pendingAllot || 0, name: '待分配', itemStyle: { color: '#fa8c16' } },
            { value: this.taskDistributionData.processing || 0, name: '进行中', itemStyle: { color: '#1890ff' } }
          ]
        }]
      })
    },

    // 初始化开票趋势图
    initInvoiceTrendChart() {
      const dom = this.$refs.invoiceTrendChart
      if (!dom) return
      if (this.chartInstances.invoiceTrend) {
        this.chartInstances.invoiceTrend.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.invoiceTrend = chart
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.invoiceTrendData.map(item => item.month),
          axisLine: { lineStyle: { color: '#f0f0f0' } },
          axisLabel: { color: '#999' }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#999',
            formatter: (value) => value === 0 ? '0' : this.formatMoneyWan(value) + '万'
          },
          splitLine: { lineStyle: { color: '#f5f5f5' } }
        },
        series: [{
          name: '开票金额',
          type: 'bar',
          barWidth: '40%',
          data: this.invoiceTrendData.map(item => item.invoiceAmount),
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#13c2c2' },
              { offset: 1, color: '#52c41a' }
            ]),
            borderRadius: [4, 4, 0, 0]
          }
        }]
      })
    },

    // 初始化合同状态分布图
    initContractStatusChart() {
      const dom = this.$refs.contractStatusChart
      if (!dom) return
      if (this.chartInstances.contractStatus) {
        this.chartInstances.contractStatus.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.contractStatus = chart
      chart.setOption({
        tooltip: { trigger: 'item' },
        legend: {
          bottom: '5%',
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: ['已签署', '已到期', '待审批']
        },
        series: [{
          name: '合同状态',
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['50%', '45%'],
          avoidLabelOverlap: false,
          itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
          label: { show: false },
          emphasis: { label: { show: false } },
          data: [
            { value: this.contractStatusData.signed || 0, name: '已签署', itemStyle: { color: '#52c41a' } },
            { value: this.contractStatusData.expired || 0, name: '已到期', itemStyle: { color: '#faad14' } },
            { value: this.contractStatusData.pending || 0, name: '待审批', itemStyle: { color: '#1890ff' } }
          ]
        }]
      })
    },

    // 初始化来源方企业统计图
    initSourceEnterpriseChart() {
      const dom = this.$refs.sourceEnterpriseChart
      if (!dom) return
      if (this.chartInstances.sourceEnterprise) {
        this.chartInstances.sourceEnterprise.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.sourceEnterprise = chart
      chart.setOption({
        tooltip: { trigger: 'item' },
        legend: {
          bottom: '2%',
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: this.sourceEnterpriseData.map(item => item.sourceOrg)
        },
        series: [{
          name: '来源方企业',
          type: 'pie',
          radius: ['35%', '65%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: true,
          itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
          label: {
            show: true,
            formatter: '{b}: {d}%',
            fontSize: 12
          },
          emphasis: { label: { show: true } },
          data: this.sourceEnterpriseData.map((item, index) => ({
            value: item.companyCount,
            name: item.sourceOrg,
            itemStyle: {
              color: ['#1890ff', '#13c2c2', '#722ed1', '#fa8c16', '#52c41a', '#9254de'][index]
            }
          }))
        }]
      })
    },

    // 初始化来源方占比图
    initSourceProportionChart() {
      const dom = this.$refs.sourceProportionChart
      if (!dom) return
      if (this.chartInstances.sourceProportion) {
        this.chartInstances.sourceProportion.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.sourceProportion = chart
      chart.setOption({
        tooltip: { trigger: 'item' },
        legend: {
          bottom: '2%',
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: this.sourceEnterpriseList.map(item => item.sourceOrg)
        },
        series: [{
          name: '来源方占比',
          type: 'pie',
          radius: ['35%', '65%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: true,
          itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
          label: {
            show: true,
            formatter: '{d}%',
            fontSize: 12
          },
          emphasis: { label: { show: true } },
          data: this.sourceEnterpriseList.map((item, index) => ({
            value: item.ratio,
            name: item.sourceOrg,
            itemStyle: {
              color: ['#1890ff', '#13c2c2', '#722ed1', '#fa8c16', '#52c41a', '#9254de'][index]
            }
          }))
        }]
      })
    },

    // 初始化来源方下企业统计图
    initSourceSubEnterpriseChart() {
      const dom = this.$refs.sourceSubEnterpriseChart
      if (!dom) return
      if (this.chartInstances.sourceSubEnterprise) {
        this.chartInstances.sourceSubEnterprise.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.sourceSubEnterprise = chart
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '15%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.sourceSubEnterpriseData.map(item => item.enterpriseName),
          axisLine: { lineStyle: { color: '#f0f0f0' } },
          axisLabel: {
            color: '#999',
            fontSize: 11,
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: '#999' },
          splitLine: { lineStyle: { color: '#f5f5f5' } }
        },
        series: [{
          name: '任务量',
          type: 'bar',
          barWidth: '50%',
          data: this.sourceSubEnterpriseData.map(item => item.taskCount),
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#409eff' },
              { offset: 1, color: '#1890ff' }
            ]),
            borderRadius: [4, 4, 0, 0]
          }
        }]
      })
    },

    // 初始化月度新增企业图
    initMonthlyNewEnterpriseChart() {
      const dom = this.$refs.monthlyNewEnterpriseChart
      if (!dom) return
      if (this.chartInstances.monthlyNewEnterprise) {
        this.chartInstances.monthlyNewEnterprise.dispose()
      }
      const chart = echarts.init(dom)
      this.chartInstances.monthlyNewEnterprise = chart
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: '8%', right: '4%', bottom: '10%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.newCompanyTrendData.map(item => item.month),
          axisLine: { lineStyle: { color: '#f0f0f0' } },
          axisLabel: { color: '#999' }
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: '#999' },
          splitLine: { lineStyle: { color: '#f5f5f5' } }
        },
        series: [{
          name: '新增企业',
          type: 'bar',
          barWidth: '45%',
          data: this.newCompanyTrendData.map(item => item.newCompanyCount),
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#722ed1' },
              { offset: 1, color: '#512da8' }
            ]),
            borderRadius: [4, 4, 0, 0]
          }
        }]
      })
    },

    // 格式化数字
    formatNumber(num) {
      if (num === undefined || num === null) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    // 格式化金额（万元）
    formatMoneyWan(num) {
      if (num === undefined || num === null) return '0.00'
      return (Number(num) / 10000).toFixed(2)
    },

    // 格式化金额（元）
    formatMoney(num) {
      if (num === undefined || num === null) return '0.00'
      const numStr = Number(num).toFixed(2)
      const parts = numStr.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.') + '元'
    },

    // 获取状态类型
    getStatusType(status) {
      if (status === '合作中') return 'success'
      if (status === '未签约') return 'warning'
      if (status === '已到期') return 'danger'
      return 'info'
    },

    // 处理窗口大小变化
    handleResize() {
      Object.values(this.chartInstances).forEach(c => c && c.resize())
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-container {
  height: calc(100vh - 80px);
  overflow: hidden;
  background-color: #f0f2f5;
  // min-height: 100%;
  .statisticsHead{
    height: 100px;
  }
  .statisticsBody{
    height: calc(100% - 100px);
    overflow-y: scroll;
    &>.el-row{
      width: 100%;
      margin: 8px 0 !important;
    }
  }

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .header-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      display: flex;
      align-items: center;

      .header-icon {
        color: #1890ff;
        margin-right: 8px;
      }
    }
  }

  .filter-section {
    background: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);

    .filter-left {
      display: flex;
      gap: 24px;

      .filter-item {
        display: flex;
        align-items: center;
        gap: 8px;

        .label {
          font-size: 13px;
          color: #666;
          white-space: nowrap;
        }
      }
    }

    .filter-right {
      display: flex;
      align-items: center;
      gap: 16px;

      .alert-info {
        background: #e6f7ff;
        border: 1px solid #91d5ff;
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 13px;
        color: #1890ff;
        display: flex;
        align-items: center;
        gap: 6px;
      }
    }
  }

  .top-cards-row {
    margin-bottom: 16px;

    .top-card {
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      gap: 16px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      position: relative;
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
      }

      &-0::after { background: #1890ff; }
      &-1::after { background: #52c41a; }
      &-2::after { background: #fa8c16; }
      &-3::after { background: #722ed1; }

      .card-icon {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
      }

      .card-content {
        .card-value {
          font-size: 24px;
          font-weight: bold;
          color: #333;
          line-height: 1.2;

          .unit {
            font-size: 14px;
            margin-left: 2px;
          }
        }

        .card-label {
          font-size: 13px;
          color: #999;
          margin: 4px 0;
        }

        .card-trend {
          font-size: 12px;
          color: #52c41a;
          display: flex;
          align-items: center;
          gap: 2px;
        }
      }
    }
  }

  .middle-cards-row {
    margin-bottom: 16px;

    .middle-card {
      background: #fff;
      padding: 16px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      position: relative;
      overflow: hidden;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .label {
          font-size: 13px;
          color: #666;
        }
      }

      .card-value {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 12px;
      }

      .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .sub-label {
          font-size: 12px;
          color: #999;
        }

        .status-tag {
          font-size: 11px;
          padding: 1px 6px;
          border-radius: 10px;
        }
      }

      .progress-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        opacity: 0.3;
      }
    }
  }

  .detail-cards-row {
    margin-bottom: 16px;

    .detail-card {
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      height: 100%;

      .card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        font-size: 20px;

        .status-tag {
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 4px;
        }
      }

      .card-title {
        font-size: 14px;
        color: #666;
        margin-bottom: 4px;
      }

      .card-value {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
      }

      .card-desc {
        font-size: 12px;
        color: #999;
        line-height: 1.6;
      }
    }
  }

  .bottom-charts-row,
  .charts-row-2,
  .charts-row-3,
  .charts-row-4 {
    margin-bottom: 16px;

    .chart-card {
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      height: 320px;
      display: flex;
      flex-direction: column;

      .chart-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .title {
          font-size: 15px;
          font-weight: bold;
          color: #333;
          padding-left: 10px;
          border-left: 4px solid #1890ff;
        }
      }

      .chart-container-inner {
        flex: 1;
        width: 100%;
      }
    }

    .table-card {
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      height: 320px;
      display: flex;
      flex-direction: column;

      .table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .title {
          font-size: 15px;
          font-weight: bold;
          color: #333;
          padding-left: 10px;
          border-left: 4px solid #1890ff;
        }

        .table-info {
          font-size: 12px;
          color: #999;
        }
      }

      .table-wrapper {
        flex: 1;
        overflow: hidden;

        ::v-deep .el-table {
          font-size: 12px;

          th {
            background-color: #fafafa;
            color: #666;
            font-weight: 600;
          }

          td {
            color: #666;
          }
        }
      }
    }

    .ranking-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding-top: 10px;

      .ranking-item {
        .ranking-info {
          display: flex;
          align-items: center;
          margin-bottom: 4px;

          .rank-num {
            width: 20px;
            height: 20px;
            border-radius: 4px;
            background: #f0f2f5;
            color: #999;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            &.rank-1 { background: #1890ff; color: #fff; }
            &.rank-2 { background: #13c2c2; color: #fff; }
            &.rank-3 { background: #722ed1; color: #fff; }
          }

          .rank-name {
            font-size: 14px;
            color: #333;
          }
        }

        .ranking-bar-wrapper {
          display: flex;
          align-items: center;
          gap: 12px;

          .el-progress {
            flex: 1;
          }

          .rank-value {
            font-size: 12px;
            color: #999;
            width: 40px;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>